import React from 'react';
import Spinner from './Spinner';
import LogoPage from './LogoPage';

export default function LoadingPage() {
	return (
		<LogoPage>
			<Spinner noDelay={true} />
		</LogoPage>
	);
}
